module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3947903ddb159c7e7cd203eb79bda07f.png";